export const SAMPLES: Record<string, string> = {
  meeting: `Q4 Planning Meeting Transcript\nDecision: Approve migration budget of $45,000.\nAction: Procurement to shortlist vendors.\nRisk: Support sunset in 70 days.`,
  invoice: `Invoice INV-2024-441\nVendor: CloudSphere LLC\nTotal: 48,816 USD\nTerms: Net 20`,
  document: `Master Service Agreement between Acme and DataCorp. Annual value: 146,000 USD. Term: 24 months.`,
};
